import { Brand, Neutrals } from './colors';

export const Background = {
  BackgroundColorDefault: Neutrals.main.White,
  BackgroundColorNeutral: Neutrals.neutralGreys.GreyNatural050,
  BackgroundColorBrand: Neutrals.coldGreys.GreyCold050,
  BackgroundColorSelected: Brand.water.Water050,
  BackgroundColorPromo: Brand.orange.Orange500,
  BackgroundColorBlur: {
    backgroundColor: `${Neutrals.main.White}CC`,
    backdropFilter: 'blur(16px)',
    WebkitBackdropFilter: 'blur(16px)',
  },
  BackgroundColorInverted: Neutrals.neutralGreys.GreyNatural900,
  BackgroundColorOnLight: Neutrals.neutralGreys.GreyNatural850,
};
